/* @flow */
import { combineReducers } from "redux";
import type { Action } from "../action";
import { VERIFICATION_STATUS_DECLINED } from "../../components/VerificationStatus";

// Кусочек стора, который помогает
// следить за тем, все ли важные
// данные пришли и можно показать
// экран пользователю.

type DataStatus = "UNAVAILABLE" | "PENDING" | "AVAILABLE" | "INVALID";

function profileStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_PROFILE":
    case "UPDATE_CURRENCY":
      return "PENDING";
    case "RECEIVE_SOCKET_MESSAGE":
      if (
        (action.payload.op === "phone-confirm-call" && !action.payload.result) ||
        action.payload.op === "user-accounts-updated" ||
        (action.payload.op === "statusChanged" &&
          action.payload.status === VERIFICATION_STATUS_DECLINED)
      ) {
        return "PENDING";
      } else {
        return state;
      }
    case "RECEIVE_PROFILE":
      return "AVAILABLE";
    case "INVALIDATE_PROFILE":
      return "INVALID";
    default:
      return state;
  }
}

function tradeSettingsStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_TRADE_SETTINGS":
    case "UPDATE_CURRENCY":
    case "UPDATE_LOCALE":
    case "REQUEST_PROFILE":
      return "PENDING";
    case "RECEIVE_TRADE_SETTINGS":
      return "AVAILABLE";
    case "INVALIDATE_TRADE_SETTINGS":
      return "INVALID";
    default:
      return state;
  }
}

function serverDataStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_SERVER_DATA":
    case "UPDATE_LOCALE":
    case "UPDATE_CURRENCY":
    case "REQUEST_PROFILE":
    case "INVALIDATE_PROFILE":
      return "PENDING";
    case "RECEIVE_SERVER_DATA":
      return "AVAILABLE";
    case "INVALIDATE_SERVER_DATA":
      return "INVALID";
    default:
      return state;
  }
}

function accountsStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "SWITCH_ACCOUNTS":
    case "REQUEST_ACCOUNTS":
    case "REQUEST_PROFILE":
      return "PENDING";
    case "RECEIVE_SOCKET_MESSAGE":
      if (action.payload.op === "user-accounts-updated") {
        return "PENDING";
      } else {
        return state;
      }
    case "RECEIVE_ACCOUNTS":
      return "AVAILABLE";
    case "INVALIDATE_PROFILE":
    case "INVALIDATE_ACCOUNTS":
      return "INVALID";
    default:
      return state;
  }
}

function operationsStatus(
  state?: DataStatus = "UNAVAILABLE",
  action: Action
): DataStatus {
  switch (action.type) {
    case "SWITCH_ACCOUNTS":
    case "REQUEST_DEAL_HISTORY":
      return "PENDING";
    case "RECEIVE_DEAL_HISTORY":
      return "AVAILABLE";
    case "INVALIDATE_DEAL_HISTORY":
      return "INVALID";
    case "SOCKET_STATE_CHANGE":
      return action.payload === WebSocket.OPEN ? "PENDING" : state;
    case "RECEIVE_SOCKET_MESSAGE":
      return action.payload.op === "operationOpened" ||
        action.payload.op === "operationClosed"
        ? "PENDING"
        : state;
    default:
      return state;
  }
}

function apiConfigsStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_API_CONFIGS":
      return "PENDING";
    case "RECEIVE_API_CONFIGS":
      return "AVAILABLE";
    case "INVALIDATE_API_CONFIGS":
      return "INVALID";
    default:
      return state;
  }
}

function apiCountriesStatus(
  state?: DataStatus = "UNAVAILABLE",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_API_COUNTRIES":
      return "PENDING";
    case "RECEIVE_API_COUNTRIES":
      return "AVAILABLE";
    case "INVALIDATE_API_COUNTRIES":
      return "INVALID";
    default:
      return state;
  }
}

function stocksStatus(
  state?: DataStatus = "UNAVAILABLE",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_STOCK_ASSETS":
    case "SWITCH_ACCOUNTS":
      return "PENDING";
    case "RECEIVE_STOCK_ASSETS":
      return "AVAILABLE";
    case "INVALIDATE_STOCK_ASSETS":
      return "INVALID";
    default:
      return state;
  }
}

function iOSShowDepositStatus(
  state?: DataStatus = "PENDING",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_IOS_SHOW_DEPOSIT":
      return "PENDING";
    case "RECEIVE_IOS_SHOW_DEPOSIT":
      return "AVAILABLE";
    case "INVALIDATE_IOS_SHOW_DEPOSIT":
      return "INVALID";
    default:
      return state;
  }
}

function withdrawOutputMethodsStatus(
  state?: DataStatus = "UNAVAILABLE",
  action: Action
): DataStatus {
  switch (action.type) {
    case "REQUEST_WITHDRAW_OUTPUT_METHODS":
      return "PENDING";
    case "RECEIVE_WITHDRAW_OUTPUT_METHODS":
      return "AVAILABLE";
    case "INVALIDATE_WITHDRAW_OUTPUT_METHODS":
      return "INVALID";
    default:
      return state;
  }
}

export default combineReducers({
  profile: profileStatus,
  tradeSettings: tradeSettingsStatus,
  serverData: serverDataStatus,
  accounts: accountsStatus,
  operations: operationsStatus,
  apiConfigs: apiConfigsStatus,
  apiCountries: apiCountriesStatus,
  stocks: stocksStatus,
  iOSShowDeposit: iOSShowDepositStatus,
  withdrawOutputMethods: withdrawOutputMethodsStatus
});



// WEBPACK FOOTER //
// ./src/redux/reducer/dataRequirementsStatus.js